import { render, staticRenderFns } from "./OsPreditiva.vue?vue&type=template&id=e2660e4a&"
import script from "./OsPreditiva.vue?vue&type=script&lang=js&"
export * from "./OsPreditiva.vue?vue&type=script&lang=js&"
import style0 from "./OsPreditiva.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports